/** @format */

import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import Loader from '@components/loader';
import { TranslationProvider } from '@context/translation-context';
const ImageGallery = lazy(() => import('./image-gallery'));

/**
 * Build Image Gallery.
 */
export const imageGallery = () => {
  const gallery = document.getElementById('image-gallery');
  if (gallery) {
    const root = createRoot(gallery);
    root.render(
      <Suspense fallback={<Loader />}>
        <TranslationProvider>
          <ImageGallery />
        </TranslationProvider>
      </Suspense>
    );
  }
};
